import { Component, ElementRef, ViewChild, Input } from '@angular/core';
import copy from 'copy-to-clipboard';
import { Utilities } from '@approot/utilities';
import { LegDescription } from '@approot/models';
import { ModalComponent } from '@approot/ui-kit';

@Component({
  selector: 'app-leg-description',
  templateUrl: './leg-description.component.html',
  styleUrls: ['./leg-description.component.scss']
})
export class LegDescriptionComponent {
  @ViewChild('tableToCopy', { static: false }) public tableToCopy: ElementRef;
  @Input() public legChecked = true;
  @Input() public legDescription: LegDescription;
  @Input() public hideCloseButton = false;
  @Input() public parentModal: ModalComponent;
  constructor(private elementRef: ElementRef) {}

  public hideDescription() {
    this.parentModal?.close();
  }

  public onCopyToClipboardClicked() {
    copy(this.formatDataForCopy(), { format: 'text/plain' });
  }

  private formatDataForCopy() {
    let textToCopy = '';
    const table = this.elementRef.nativeElement.querySelectorAll('.table-data');
    let tableSelectedIndex = 0;
    this.legDescription.description.forEach((item, index) => {
      if (item.title) {
        textToCopy = textToCopy + item.title;
      } else if (item.text) {
        textToCopy = textToCopy + item.text;
      } else if (item.headers) {
        textToCopy =
          textToCopy + Utilities.tableToExcelFormat(table[tableSelectedIndex]);
        tableSelectedIndex++; // if more tables look at the next table
      }
      if (index !== this.legDescription.description.length - 1) {
        // if we are on the last item don't add a new line
        textToCopy += '\n';
      }
    });

    return textToCopy;
  }
}
